import { Box, Stack } from "@mui/system";
import React from "react";
import { ChatBubble } from "./chat-bubble";
import { useAppSelector } from "../../hooks";
import { approvalSlice } from "../../features/approvals/approvalsSlice";
import { Divider, Typography } from "@mui/material";
import { ChatMessage } from "./chat-message";
import { IApprovalItemComment } from "../../services/thumbz-base-api";

interface IChatBodyProps {}

export const ChatBody: React.FC<IChatBodyProps> = () => {
  const comments = useAppSelector(approvalSlice.selectors.revisionComments);
  const commentsCount = useAppSelector(
    approvalSlice.selectors.revisionComments,
  );

  const ChatContent = () => {
    if (commentsCount.length === 0) {
      return (
        <Box
          sx={{
            display: "flex",
            flex: "1 1 auto",
            justifyContent: "center",
            alignItems: "center",
            p: 3,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Nenhuma observação
          </Typography>
        </Box>
      );
    }

    const getSenderId = (c: IApprovalItemComment) => {
      if (c.aic_by === "customer") {
        return `customer-${c.customer?.cust_id}`;
      }
      if (c.aic_by === "user") {
        return `user-${c.user?.usu_id}`;
      }
      return "system";
    };

    return (
      <Stack spacing={2} sx={{ flex: "1 1 auto", overflowY: "auto", p: 3 }}>
        {comments.map((comment, index) => {
          const prev = comments[index - 1];
          const showSenderInfo =
            !prev || getSenderId(prev) !== getSenderId(comment);
          return (
            <ChatBubble
              key={comment.aic_id}
              comment={comment}
              showSenderInfo={showSenderInfo}
            />
          );
        })}
      </Stack>
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flex: "1 1 auto",
        flexDirection: "column",
        minHeight: 0,
      }}
    >
      <ChatContent />
      <Box my={1}>
        <Divider />
      </Box>
      <Box p={1}>
        <ChatMessage />
      </Box>
    </Box>
  );
};
